import React, { useEffect, useMemo } from "react";
import { Route, useHistory, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Loader } from "../Loader";
import { LevelNotification } from "@/components/student/LevelNotification";
import { ExitModalContainer } from "@/containers/site/ExitModalContainer";
import { TrialLessonModalContainer } from "@/containers/site/TrialLessonModal";
import { WelcomeModal } from "@/containers/student/WelcomeModal";
import { useCitiesQuery } from "@/graphql";
import { mainPage, trialLessonModalHash, welcomeModalHash } from "@/urls";
export const AppInitializer = ({ children }) => {
    const { data: cityData } = useCitiesQuery();
    const history = useHistory();
    const location = useLocation();
    const [modalShown, setModalShown] = React.useState(false);
    const [levelNotification, setLevelNotification] = React.useState({
        following: false,
        id: null,
        warningDescription: null,
        cityInput: null,
    });
    const [isExitModalOpen, setIsExitModalOpen] = React.useState(false);
    useEffect(() => {
        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        const openExitModal = () => {
            if (!sessionStorage.getItem("exitModalShown")) {
                setIsExitModalOpen(true);
                sessionStorage.setItem("exitModalShown", "true");
            }
        };
        if (isMobile || window.innerWidth < 768) {
            setTimeout(() => {
                openExitModal();
            }, 10000);
        }
        else {
            const handleMouseLeave = () => {
                openExitModal();
            };
            document.addEventListener("mouseleave", handleMouseLeave);
            return () => {
                document.removeEventListener("mouseleave", handleMouseLeave);
            };
        }
    }, []);
    const cities = useMemo(() => cityData === null || cityData === void 0 ? void 0 : cityData.cities.map(city => city), [cityData]);
    const handleAgreeCity = () => {
        setLevelNotification({
            following: false,
            id: null,
            warningDescription: null,
            cityInput: null,
        });
    };
    const handleLaterCity = () => {
        setLevelNotification({
            following: false,
            id: null,
            warningDescription: null,
            cityInput: null,
        });
    };
    React.useEffect(() => {
        if (!modalShown && !localStorage.getItem("cityChoised")) {
            setModalShown(true);
            history.push(mainPage);
            setLevelNotification({
                following: true,
                id: null,
                warningDescription: null,
                cityInput: null,
            });
            !localStorage.getItem("cityName") &&
                localStorage.setItem("cityName", "Київ");
            localStorage.setItem("cityChoised", "true");
        }
    }, [location.pathname, modalShown]);
    if (typeof window === "undefined") {
        return React.createElement(Loader, null);
    }
    return (React.createElement(React.Fragment, null,
        children,
        React.createElement(Route, { render: () => (React.createElement(React.Fragment, null,
                React.createElement(WelcomeModal, { isOpen: history.location.hash === welcomeModalHash, onRequestClose: () => history.replace(Object.assign(Object.assign({}, history.location), { hash: "" })) }),
                React.createElement(ToastContainer, null),
                React.createElement(TrialLessonModalContainer, { isOpen: history.location.hash === trialLessonModalHash, onRequestClose: () => history.replace(Object.assign(Object.assign({}, history.location), { hash: "" })) }),
                React.createElement(ExitModalContainer, { isOpen: isExitModalOpen, onRequestClose: () => setIsExitModalOpen(false) }),
                levelNotification.following && (React.createElement(LevelNotification, { isOpen: levelNotification.following, agreeLevel: handleAgreeCity, cancelAddition: handleLaterCity, title: "Bonjour!", warningDescription: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0432\u0438\u0431\u0435\u0440\u0438 \u043C\u0456\u0441\u0442\u043E \u0437\u0456 \u0441\u043F\u0438\u0441\u043A\u0443.\n              \u0426\u0435 \u0434\u043E\u043F\u043E\u043C\u043E\u0436\u0435 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u0438 \u043A\u043E\u0440\u0435\u043A\u0442\u043D\u0443 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044E \u0434\u043B\u044F \u0442\u0435\u0431\u0435.", citiesInput: cities })))) })));
};
